"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _webApiClientSingleton = _interopRequireDefault(require("../webApiClientSingleton"));
var logError = function logError(message) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  _webApiClientSingleton["default"].instance.logging.errorLog({
    message: message,
    context: {
      error: error.message
    }
  });
};
var _default = logError;
exports["default"] = _default;
//# sourceMappingURL=logError.js.map